<template>
  <div class="violation-manage-modal">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      @open="handleOpen"
      @closed="handleClosed"
      width="45%"
    >
      <div class="dialog-inner">
        <div class="violation-manage-row">
          <span>
            风险预警：未处理分值大于等于
          </span>
          <el-input @input="(val) => this.scoreRules(val, 'riskScore', 3)" maxlength="3" v-model="data.riskScore">
            <template slot="append">分</template>
          </el-input>
          <span>
            或未处理罚款大于
          </span>
          <el-input @input="(val) => this.scoreRules(val, 'riskFine', 4)" maxlength="4" v-model="data.riskFine">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="violation-manage-row">
          <span>
            高危预警：未处理分值大于等于
          </span>
          <el-input @input="(val) => this.scoreRules(val, 'highRiskScore', 3)" maxlength="3" v-model="data.highRiskScore">
            <template slot="append">分</template>
          </el-input>
          <span>
            或未处理罚款大于
          </span>
          <el-input @input="(val) => this.scoreRules(val, 'highRiskFine', 4)" maxlength="4" v-model="data.highRiskFine">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="violation-manage-row">
          <span>
            超时预警：达到风险预警或高危预警，超过
          </span>
          <el-input @input="(val) => this.scoreRules(val, 'overtimeDays', 2)" maxlength="2" v-model="data.overtimeDays">
            <template slot="append">天</template>
          </el-input>
          <span>
            仍未处理完毕
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { limitMoreZero } from '@/utils/validate'
// const defaultParams = {
//   overtimeDays: 0, // 超时预警天数
//   highRiskFine: 0, // 高危预警扣款数
//   highRiskScore: 0, // 高危预警扣分数
//   riskScore: 0, // 风险预警扣分数
//   riskFine: 0 // 风险预警扣款数
// }

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      data: {},
      dialogVisible: false,
      submitLoading: false,
    }
  },
  methods: {
    handleOpen() {
      this.data = JSON.parse(JSON.stringify(this.defaultData))
    },
    handleClosed() {
      this.submitLoading = false
      this.data = {}
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleConfirm() {
      if (this.submitLoading) return
      if (Object.values(this.data).some((item) => !item)) {
        this.$message.error('请将违章预警分级配置完整')
        return
      }

      this.submitLoading = true
      this.$emit('change', this.data)
      this.dialogVisible = false
    },
    // 分值、罚款 取值范围校验
    // eslint-disable-next-line vue/no-unused-properties
    scoreRules(val, type, max) {
      // eslint-disable-next-line no-shadow
      limitMoreZero(val, (val) => {
        this.$set(this.data, type, val)
      }, max, false)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-inner {
  padding: 8px 8px 0 8px;
  ::v-deep .el-input {
    margin: 0 8px 0 8px;
    width: 112px;
  }
  ::v-deep .el-input-group__append {
    width: 32px !important;
    padding: 0;
    box-sizing: border-box;
  }
  .violation-manage-row {
    display: flex;
    align-content: center;
    margin-bottom: 24px;
    span {
      display: flex;
      align-items: center;
    }
  }
}
</style>
